<template>
  <div>
    <b-row>
      <b-col>
        <h5 class="page-title">
          <span>{{ $t("Equipments") }}</span>
        </h5>
      </b-col>
    </b-row>
    <br>
    <b-row>
      <b-col>
        <b-card class="bg-t-dark default-form">
          <b-row>
            <b-col>
              <span>{{ $t("Filters") }}:</span>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col md="4">
              <b-row>
                <b-col>
                  <small>{{ $t("Search") }}</small>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-input id="search-input" v-model="search" @keyup="searchKeyup"
                    :placeholder="$t('Filter by serial number, pim, am, ventilation board...')" />
                  <!-- 'serial_number', 'pim_serial_number',
                     'am_serial_number', 'ventilation_board_serial_number',
                     'pim_mac_address_one', 'pim_mac_address_two' -->
                </b-col>
              </b-row>
            </b-col>
            <b-col md="2">
              <b-row>
                <b-col>
                  <small>{{ $t("Device model") }}<b-spinner class="mx-2" small v-if="isLoadingFilters" /></small>
                </b-col>
              </b-row>
              <b-row>
                <b-col id="device-filter">
                  <b-form-select @change="loadDevices()" class="form-control form-select" v-model="model">
                    <b-form-select-option v-for="m in models" :key="m.id" :value="m.id" v-if="m.id">
                      {{ m.name }}
                    </b-form-select-option>
                  </b-form-select>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="2">
              <b-row>
                <b-col>
                  <small>{{ $t("Software version") }}<b-spinner class="mx-2" small v-if="isLoadingFilters" /></small>
                </b-col>
              </b-row>
              <b-row>
                <b-col id="software-filter">
                  <b-form-select @change="loadDevices()" class="form-control form-select" placeholder="Selecione"
                    v-model="version">
                    <b-form-select-option v-for="m in versions" :key="m.id" :value="m.id" v-if="m.id">
                      {{ m.name }}
                    </b-form-select-option>
                  </b-form-select>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="2">
              <b-row>
                <b-col>
                  <small>{{ $t("Regulatory target") }}<b-spinner class="mx-2" small v-if="isLoadingFilters" /></small>
                </b-col>
              </b-row>
              <b-row>
                <b-col id="regulatory-filter">
                  <b-form-select @change="loadDevices()" class="form-control form-select" placeholder="Selecione"
                    v-model="regulatory_agency">
                    <b-form-select-option v-for="m in regulatory_agencies" :key="m.id" :value="m.id" v-if="m.id">
                      {{ m.name }}
                    </b-form-select-option>
                  </b-form-select>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="2">
              <b-row>
                <b-col>
                  &nbsp;
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-btn variant="outline-t-blue" @click="clear_filters">
                    {{ $t("Clear") }}
                  </b-btn>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <div v-if="isLoadingDevices" class="mt-3">
      <b-row v-for="n in 4" :key="`skel-${n}`" class="mt-3">
        <b-col>
          <EquipmentCardSkeleton />
        </b-col>
      </b-row>
    </div>

    <div v-else>
      <b-row class="mt-3" v-for="i, j in items" :key="j">
        <b-col>
          <EquipmentSettingsCard :serial_number="i.serial_number" :mode="i.mode" :date="i.date"
            :device_name="i.device_name" :device_id="i.device_id" />
        </b-col>
      </b-row>
    </div>

    <div class="mt-3" style="display:flex;">
      <div style="text-align:end; margin-top:13px;margin-left: auto;">
        {{ rows }} {{ $t("Equipments") }}
      </div>
      <div>
        <b-pagination @change="loadDevices" v-model="page" :total-rows="rows" :per-page="15" align="right" />
      </div>
    </div>
  </div>
</template>

<script>
import EquipmentSettingsCard from "./components/EquipmentSettingsCard.vue"
import EquipmentCardSkeleton from "./components/EquipmentCardSkeleton.vue"

export default {
  components: {
    EquipmentSettingsCard,
    EquipmentCardSkeleton
  },
  methods: {
    searchKeyup() {
      this.page = 1
      this.loadDevices()
    },
    loadDevices(p) {
      this.$Progress.start()
      this.isLoadingDevices = true

      let filters = `?`
      if (this.version) {
        filters = `${filters}base_software=${this.version}&`
      }
      if (this.regulatory_agency) {
        filters = `${filters}regulatory_target=${this.regulatory_agency}&`
      }
      if (this.model) {
        filters = `${filters}model=${this.model}&`
      }
      if (this.search) {
        filters = `${filters}search=${this.search}&`
      }
      if (p) {
        this.page = p
      }

      filters = `${filters}page=${this.page}&page_size=15&`

      return this.$utils.request(
        `medicaldevice/device/${filters}`,
        'GET',
        {},
        (r) => {
          this.items = []
          r.data.results.forEach(i => {
            this.items.push({
              device_id: i.id,
              serial_number: i.serial_number,
              mode: i.regulatory_target.name,
              date: new Date(i.modified_at).toLocaleDateString(),
              device_name: i.name,
            })
          })
          this.rows = r.data.count
          this.isLoadingDevices = false
          this.$Progress.finish()
        }
      )
    },
    clear_filters() {
      this.search = ''
      this.regulatory_agency = null
      this.model = null
      this.version = null
      this.loadDevices()
    },
    getModels() {
      this.$Progress.start()
      return this.$utils.request(
        'medicaldevice/devicemodel/',
        'GET',
        {},
        (r) => {
          this.models = r.data
          this.$Progress.finish()
        },
      )
    },
    getVersions() {
      this.$Progress.start()
      return this.$utils.request(
        'medicaldevice/devicebasesoftware/',
        'GET',
        {},
        (r) => {
          this.versions = r.data
          this.$Progress.finish()
        },
      )
    },
    getRegulatory() {
      this.$Progress.start()
      return this.$utils.request(
        'medicaldevice/regulatoryagency/',
        'GET',
        {},
        (r) => {
          this.regulatory_agencies = r.data.results || r.data
          this.$Progress.finish()
        },
      )
    },
  },
  mounted() {

    this.$Progress.start();
    this.loadDevices();

    this.isLoadingFilters = true

    Promise.all([
      this.getModels(),
      this.getVersions(),
      this.getRegulatory()
    ]).then(() => {
      this.isLoadingFilters = false
      this.$Progress.finish()
    }).catch(() => {
      this.isLoadingFilters = false
      this.$Progress.fail()
    })
  },
  data() {
    return {
      page: 1,
      rows: 1,
      search: '',
      items: [],
      models: [],
      model: null,
      versions: [],
      version: null,
      regulatory_agencies: [],
      regulatory_agency: null,
      isLoadingFilters: false,
      isLoadingDevices: false,
      fields: [
        {
          key: 'date',
          label: 'Data'
        },
        {
          key: 'client',
          label: 'Cliente'
        },
        {
          key: 'model',
          label: 'Modelo'
        },
        {
          key: 'amount',
          label: 'Qtd'
        },
        {
          key: 'mode',
          label: 'Modo'
        },
      ]
    }
  }
}
</script>

<style lang="scss">
.order-filters {
  .form-control {
    color: white;
    background: #767E8A;
    border: #767E8A50;
  }

  .form-control:focus {
    color: white;
    background: #767E8A;
    border: #767E8A50;
  }

  .form-select {
    background-image: url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 16px 12px;
  }

  ::-webkit-calendar-picker-indicator {
    filter: invert(1);
  }
}
</style>
